var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.finishedLoading)?_c('section',[_c('h4',{staticClass:"is-size-4"},[_vm._v("Loading student data...")]),_c('b-skeleton',{attrs:{"width":"20%","animated":""}}),_c('b-skeleton',{attrs:{"width":"40%","animated":""}}),_c('b-skeleton',{attrs:{"width":"80%","animated":""}}),_c('b-skeleton',{attrs:{"animated":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }